import { Saga } from 'redux-saga'
import { sagas } from './sagas'

type RegisterSagas = (sagas: Saga[]) => void

export const registerSagas: RegisterSagas = (sagasToRegister = []) =>
  sagasToRegister.forEach((saga) => sagas.push(saga))
